export const GET_QUIZ_QUESTION_RESPONSE_GRADING = `
  query GetQuizQuestionResponseGrading($quizAttemptId: ID!, $quizQuestionId: ID!, $topicApiName: ID!) {
    getQuizQuestionResponseGrading(quizAttemptId: $quizAttemptId, quizQuestionId: $quizQuestionId, topicApiName: $topicApiName) {
      status
      attempt {
        quizAttemptId
        topicApiName
        tbid
        status
        questions {
          quizQuestionId
          response {
            agentGrade
            pointScore
            maxPoints
            userResponse
            agentFeedback
          }
        }
        results {
          overallScore
          scoreThresholdMet
          finishedAt
          retakeAllowed
        }
      }
    }
  }
`;
